var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPhotoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.574,
    height: 21.5,
    viewBox: "0 0 22.574 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-edit-photo",
    transform: "translate(-0.808 -1.169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(1.058 1.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M16.338,288.13a.394.394,0,0,0-.274.115q-3.762,3.765-7.524,7.527a.394.394,0,0,0-.116.279v2.787a.394.394,0,0,0,.4.393h2.787a.394.394,0,0,0,.276-.116q3.764-3.762,7.527-7.524a.394.394,0,0,0,0-.558l-2.786-2.786a.394.394,0,0,0-.284-.116Zm.006.95,2.23,2.231-1.116,1.116-2.23-2.231Zm-1.671,1.676,2.228,2.229-5.458,5.458H9.212v-2.228Z",
    transform: "translate(2.549 -278.231)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M8.7,285.719a3.942,3.942,0,1,0,3.943,3.942A3.947,3.947,0,0,0,8.7,285.719Zm0,.788a3.153,3.153,0,1,1-3.152,3.153A3.149,3.149,0,0,1,8.7,286.507Z",
    transform: "translate(0.756 -279.412)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M4.752,285.978a.788.788,0,1,1-.788-.788.788.788,0,0,1,.788.788Z",
    transform: "translate(-0.021 -279.671)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M8.548,281.485a2.517,2.517,0,0,0-1.99,1.079,3.979,3.979,0,0,0-.751,2.072H1.454a.394.394,0,0,0-.4.4v13.4a.4.4,0,0,0,.4.393h9.613a.394.394,0,0,0,0-.788H1.847V285.426H6.182a.4.4,0,0,0,.4-.393,3.36,3.36,0,0,1,.611-2,1.706,1.706,0,0,1,1.359-.762H12.49a1.7,1.7,0,0,1,1.358.762,3.36,3.36,0,0,1,.611,2,.4.4,0,0,0,.4.393H19.19V290.2a.394.394,0,1,0,.788,0v-5.17a.394.394,0,0,0-.4-.4H15.231a3.968,3.968,0,0,0-.754-2.072,2.511,2.511,0,0,0-1.987-1.079Z",
    transform: "translate(-1.058 -281.485)",
    stroke: "#000",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPhotoIcon);
export default __webpack_public_path__ + "static/media/editPhotoIcon.ba954008695e115fbd00e2bbeddc2fd1.svg";
export { ForwardRef as ReactComponent };